module.exports = __webpack_public_path__ + "img/nodata.bdfc8bd2.png";